import { defaultChatConfig } from "./five9ChatDefaultConfig";
import { Five9ChatConfig } from "../five9Chat";

const chatConfig: { [key: string]: Five9ChatConfig } = {
  "en-US": {
    ...defaultChatConfig
  },
  "es-US": {
    ...defaultChatConfig,
    title: "Young Living Live Help - US/ES",
    profiles: "US Spanish Chat",
    lang:"https://five9-chat.ec.youngliving.com/five9-chat-lang-es.json"
  },
  "en-CA": {
    ...defaultChatConfig,
    title: "Young Living Live Help - CA",
    profiles: "Canada Chat"
  }
};

function getConfigForLocale(locale: string): Five9ChatConfig | undefined {
  const config = chatConfig[locale];

  if (!config)
    return undefined;
  
  return config;
}

export { getConfigForLocale };
